<template>
  <div class="sell-points">
    <div class="info" @click="showTotalIntro" tabindex="0">
      <div class="introduce">
        <div class="intro-content" :class="showTotal ? 'unfold' : 'fold'" :title="introduce" ref="desc">
          <span class="merchant-desc" v-if="introduce">{{ introduce }}</span>
          <div
            class="control"
            v-if="showExchangeButton"
            v-track="trackData.baseInfoClick({ sku_id: skuId, info_content: 6 })"
          >
            <v-icon class="arrow-down" name="arrow-right-v3" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import trackData from '../trackData'

export default {
  name: 'sell-points',
  props: {
    currentSuiteInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    skuInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      trackData,
      // 商品介绍内容 是否展示所有文本内容
      showTotal: false,
      // 是否显示展开收起按钮
      showExchangeButton: false
    }
  },
  computed: {
    skuId() {
      return this.skuInfo.commoditySkuBaseInfo.skuId
    },
    introduce() {
      let l = ''
      let r = ''
      let currentSuite = this.currentSuiteInfo || {}
      let promotion = this.skuInfo?.commoditySkuBaseInfo?.promotion
      if (currentSuite && currentSuite.promotion) l = currentSuite.promotion
      else if (promotion) l = promotion
      if (currentSuite && currentSuite.brief) r = currentSuite.brief
      else r = this.skuInfo?.commoditySkuBaseInfo?.brief
      r = r.split(/\s*\|\s*/).join(' · ')
      if (l) return `【${l}】${r}`
      else return `${r}`
    }
  },
  methods: {
    // 切换箭头
    showTotalIntro() {
      if (this.showExchangeButton) {
        this.showTotal = !this.showTotal
      }
    },
    dealDesc() {
      this.$nextTick(() => {
        if (!this.$refs.desc) {
          return
        }
        // 获取文本行数，超出两行展示查看更多按钮
        let textLines = document.querySelector('.merchant-desc').getClientRects().length
        // 显示展开收起按钮
        this.showExchangeButton = textLines > 1
        this.showTotal = !this.showExchangeButton
        this.$emit('changeShowButton', this.showExchangeButton)
      })
    }
  },
  watch: {
    introduce: {
      handler(val) {
        this.dealDesc()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-5 {
  .info .introduce .intro-content.fold {
    max-height: 60px;
  }
}
</style>
